import React from "react";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import SportEntriesAthletesTable from "components/common/entries/SportEntriesAthletesTable";
import { ALL_URL } from "helpers/utils";

const SportEntriesAthlete = ({data}) => {
    const [dataState, setDataState] = React.useState([]);
    const [message, setMessage] = React.useState('');
    const {mirs_discipline,mirs_event} = useUrlFriendlyToParameters()

    React.useEffect(() => {

        // let athletes = data?.persons?.filter(row => row.mainFunction?.functionCode === 'AA01') // Only shows the Athletes
        let athletes = data?.filter(row => row.mainFunction?.functionCode === 'AA01') // Only shows the Athletes
  
        if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
            athletes = athletes?.filter(item => item?.disciplines?.some(itemDiscipline => itemDiscipline?.code === mirs_discipline))
        }
        // if (mirs_event && mirs_event !== ALL_URL.ALL_EVENT) {
        //     athletes = athletes?.map(athlete =>( {...athlete,registeredEvents: athlete?.registeredEvents?.filter(event => event?.code === mirs_event)}))
        // }
        if (mirs_event && mirs_event !== ALL_URL.ALL_EVENT) {
            athletes = athletes
              .map(athlete => ({
                ...athlete,
                registeredEvents: athlete?.registeredEvents?.filter(event => event?.code === mirs_event)
              }))
              .filter(athlete => athlete?.registeredEvents?.length > 0);
        }
        setMessage('');
        setDataState(athletes);
    }, [data, mirs_discipline, mirs_event]);

    return (<>
        {dataState && <SportEntriesAthletesTable data={dataState} key={`athletes`} />}
    </>
    )
};
export default SportEntriesAthlete

